import { getPrcCookieValue } from 'utils/primeUtil';
import _get from 'lodash.get';

// eslint-disable-next-line import/prefer-default-export
export function setValue({ artData, isAppView, isWapView, msid }) {
  // console.log(state.articleshow.data[params.msid]);
  const sec1 = _get(artData, 'navsubsecs.subsec1.subsecname1', '');
  const sec2 = _get(artData, 'navsubsecs.subsec2.subsecname2', '');
  let rpmidval = 'articleshow';
  rpmidval += sec1 ? `_${sec1}` : '';
  rpmidval += isAppView ? '_apptrue' : '';
  rpmidval = isWapView ? rpmidval : '';
  const prcValue = getPrcCookieValue();
  const nonprimePrcVal = [0, 2, 6, 7];
  const isUserNotPrime = nonprimePrcVal.indexOf(prcValue) > -1;
  window.tgtkeys = {
    Arc1: '',
    BL: '',
    FIC: '',
    Hyp1: '',
    LastSubSCN: '',
    PGT: '',
    SCN: sec1,
    SCP: '',
    SubSCN: sec2,
    Tmpl_SCN: '',
    crtotoi: '',
    ctnkeyword: _get(artData, 'seo.keywords', ''),
    rpmid: rpmidval,
    templatetype: 'articleshow',
    primeusertype: isUserNotPrime === true ? prcValue : '',
    msid,
  };
}
